/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Notlist_Affiliated1Inputs */

const id_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berafiliasi dengan Epic Games: Kami adalah proyek independen berbasis komunitas dan tidak didukung secara resmi atau terkait dengan Epic Games dengan cara apa pun.`)
};

const ms_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berafiliasi dengan Epic Games: Kami adalah projek bebas didorong komuniti dan tidak disokong secara rasmi atau dikaitkan dengan Epic Games dalam apa jua cara.`)
};

const da_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilknyttet Epic Games: Vi er et uafhængigt, fællesskabsdrevet projekt og er ikke officielt godkendt eller associeret med Epic Games på nogen måde.`)
};

const de_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbunden mit Epic Games: Wir sind ein unabhängiges, community-getriebenes Projekt und werden in keiner Weise offiziell von Epic Games unterstützt oder sind mit ihnen verbunden.`)
};

const en_us2_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affiliated with Epic Games: We are an independent, community-driven project and not officially endorsed or associated with Epic Games in any way.`)
};

const es_es2_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afiliado con Epic Games: Somos un proyecto independiente e impulsado por la comunidad, no respaldado ni asociado oficialmente con Epic Games de ninguna manera.`)
};

const es_mx2_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afiliado con Epic Games: Somos un proyecto independiente impulsado por la comunidad, no respaldado ni asociado oficialmente con Epic Games de ninguna manera.`)
};

const fil_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaakibat ng Epic Games: Kami ay isang independyente, proyektong pinapatakbo ng komunidad at hindi opisyal na ini-endorso o kaakibat ng Epic Games sa anumang paraan.`)
};

const fr_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affilié à Epic Games : Nous sommes un projet indépendant et communautaire, non officiellement approuvé ou associé à Epic Games de quelque manière que ce soit.`)
};

const it_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affiliato con Epic Games: Siamo un progetto indipendente guidato dalla community e non ufficialmente approvato o associato con Epic Games in alcun modo.`)
};

const hu_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games-szel társult: Független, közösség által működtetett projekt vagyunk, amely semmilyen módon nem áll hivatalos kapcsolatban az Epic Games-szel.`)
};

const nl_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gelieerd aan Epic Games: We zijn een onafhankelijk, community-gestuurd project en niet officieel onderschreven of geassocieerd met Epic Games op enigerlei wijze.`)
};

const no_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilknyttet Epic Games: Vi er et uavhengig, fellesskapsdrevet prosjekt og ikke offisielt godkjent eller assosiert med Epic Games på noen måte.`)
};

const pl_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powiązany z Epic Games: Jesteśmy niezależnym projektem społecznościowym i nie jesteśmy oficjalnie zatwierdzeni ani powiązani z Epic Games w żaden sposób.`)
};

const pt_br2_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afiliado à Epic Games: Somos um projeto independente e voltado para a comunidade e não endossado oficialmente ou associado à Epic Games de forma alguma.`)
};

const pt_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afiliado à Epic Games: Somos um projeto independente e orientado pela comunidade, sem qualquer endosso ou associação oficial com a Epic Games.`)
};

const ro_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afiliat cu Epic Games: Suntem un proiect independent, condus de comunitate, fără susținere sau asociere oficială cu Epic Games.`)
};

const fi_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sidoksissa Epic Gamesiin: Olemme itsenäinen, yhteisön ylläpitämä projekti, jota Epic Games ei ole virallisesti hyväksynyt tai joka ei ole millään tavalla yhteydessä Epic Gamesiin.`)
};

const sv_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anslutet till Epic Games: Vi är ett oberoende, community-drivet projekt och inte officiellt godkänt eller associerat med Epic Games på något sätt.`)
};

const vi_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên kết với Epic Games: Chúng tôi là một dự án độc lập do cộng đồng điều hành và không được Epic Games xác nhận hoặc liên kết chính thức dưới bất kỳ hình thức nào.`)
};

const tr_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games ile bağlantılı: Biz bağımsız, topluluk odaklı bir projeyiz ve Epic Games ile hiçbir şekilde resmi olarak onaylanmış veya ilişkilendirilmiş değiliz.`)
};

const cs_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidružený k Epic Games: Jsme nezávislý, komunitně řízený projekt a nejsme nijak oficiálně podpořeni nebo spojeni s Epic Games.`)
};

const bg_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свързан с Epic Games: Ние сме независим, ръководен от общността проект и не сме официално одобрени или свързани с Epic Games по никакъв начин.`)
};

const ru_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ресурсом аффилированным с Epic Games: Мы независимый проект, управляемый сообществом, и не имеем официальной поддержки или связи с Epic Games.`)
};

const uk_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пов'язаний з Epic Games: Ми є незалежним проєктом спільноти, який не підтримується офіційно та не пов'язаний з Epic Games.`)
};

const ar_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تابعًا لـ Epic Games: نحن مشروع مستقل مدفوع من المجتمع وغير معتمد رسميًا أو مرتبط بـ Epic Games بأي شكل.`)
};

const hi_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games से संबद्ध: हम एक स्वतंत्र, समुदाय-संचालित परियोजना हैं और किसी भी तरह से आधिकारिक रूप से समर्थित या Epic Games से संबद्ध नहीं हैं।`)
};

const th_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บริษัทในเครือของ Epic Games: เราเป็นโครงการอิสระที่ขับเคลื่อนโดยชุมชน และไม่ได้รับการรับรองอย่างเป็นทางการหรือเกี่ยวข้องกับ Epic Games ในทางใดทางหนึ่ง`)
};

const ja_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games の関連会社：私たちは独立したコミュニティ主導のプロジェクトであり、Epic Games とは公式に承認されておらず、関連もありません。`)
};

const zh_cn2_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`与Epic Games有关联：我们是一个独立的、社区驱动的项目，未以任何方式得到Epic Games的官方认可或关联。`)
};

const zh_hant1_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`與Epic Games有關聯：我們是一個獨立的、社群驅動的專案，未以任何方式得到Epic Games的官方認可或關聯。`)
};

const ko_about_notlist_affiliated1 = /** @type {(inputs: About_Notlist_Affiliated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games와 제휴: 우리는 독립적인 커뮤니티 기반 프로젝트이며, Epic Games와 공식적으로 승인되거나 관련되지 않았습니다.`)
};

/**
* | output |
* | --- |
* | "Affiliated with Epic Games: We are an independent, community-driven project and not officially endorsed or associated with Epic Games in any way." |
*
* @param {About_Notlist_Affiliated1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const about_notlist_affiliated1 = /** @type {((inputs?: About_Notlist_Affiliated1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Notlist_Affiliated1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_about_notlist_affiliated1(inputs)
	if (locale === "ms") return ms_about_notlist_affiliated1(inputs)
	if (locale === "da") return da_about_notlist_affiliated1(inputs)
	if (locale === "de") return de_about_notlist_affiliated1(inputs)
	if (locale === "en-US") return en_us2_about_notlist_affiliated1(inputs)
	if (locale === "es-ES") return es_es2_about_notlist_affiliated1(inputs)
	if (locale === "es-MX") return es_mx2_about_notlist_affiliated1(inputs)
	if (locale === "fil") return fil_about_notlist_affiliated1(inputs)
	if (locale === "fr") return fr_about_notlist_affiliated1(inputs)
	if (locale === "it") return it_about_notlist_affiliated1(inputs)
	if (locale === "hu") return hu_about_notlist_affiliated1(inputs)
	if (locale === "nl") return nl_about_notlist_affiliated1(inputs)
	if (locale === "no") return no_about_notlist_affiliated1(inputs)
	if (locale === "pl") return pl_about_notlist_affiliated1(inputs)
	if (locale === "pt-BR") return pt_br2_about_notlist_affiliated1(inputs)
	if (locale === "pt") return pt_about_notlist_affiliated1(inputs)
	if (locale === "ro") return ro_about_notlist_affiliated1(inputs)
	if (locale === "fi") return fi_about_notlist_affiliated1(inputs)
	if (locale === "sv") return sv_about_notlist_affiliated1(inputs)
	if (locale === "vi") return vi_about_notlist_affiliated1(inputs)
	if (locale === "tr") return tr_about_notlist_affiliated1(inputs)
	if (locale === "cs") return cs_about_notlist_affiliated1(inputs)
	if (locale === "bg") return bg_about_notlist_affiliated1(inputs)
	if (locale === "ru") return ru_about_notlist_affiliated1(inputs)
	if (locale === "uk") return uk_about_notlist_affiliated1(inputs)
	if (locale === "ar") return ar_about_notlist_affiliated1(inputs)
	if (locale === "hi") return hi_about_notlist_affiliated1(inputs)
	if (locale === "th") return th_about_notlist_affiliated1(inputs)
	if (locale === "ja") return ja_about_notlist_affiliated1(inputs)
	if (locale === "zh-CN") return zh_cn2_about_notlist_affiliated1(inputs)
	if (locale === "zh-Hant") return zh_hant1_about_notlist_affiliated1(inputs)
	return ko_about_notlist_affiliated1(inputs)
});
export { about_notlist_affiliated1 as "about.notList.affiliated" }